var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 45,
    height: 46,
    viewBox: "0 0 45 46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16101",
    "data-name": "Rectangle 16101",
    width: 18.622,
    height: 18.643,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_15413",
    "data-name": "Group 15413",
    transform: "translate(-1154 -256)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_16100",
    "data-name": "Rectangle 16100",
    width: 45,
    height: 46,
    rx: 22.5,
    transform: "translate(1154 256)",
    fill: "#ef6286"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15412",
    "data-name": "Group 15412",
    transform: "translate(1167 270)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15411",
    "data-name": "Group 15411",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_41212",
    "data-name": "Path 41212",
    d: "M14.1,11.3H11.5c-.205,0-.205,0-.205.211,0,1.7,0,3.395,0,5.092A1.912,1.912,0,0,1,10.1,18.474a1.98,1.98,0,0,1-2.68-1.216,2.427,2.427,0,0,1-.091-.695c-.008-1.693,0-3.386,0-5.079,0-.184,0-.182-.184-.182-1.727,0-3.454,0-5.181,0A1.985,1.985,0,0,1,1.25,7.469a2.2,2.2,0,0,1,.738-.13c1.727-.011,3.454-.006,5.181-.005.151,0,.156,0,.156-.174q0-2.565,0-5.13a1.946,1.946,0,0,1,.64-1.51,1.986,1.986,0,0,1,3.259.946,2.279,2.279,0,0,1,.069.57c0,1.706,0,3.412,0,5.118,0,.181,0,.181.188.181,1.68,0,3.36,0,5.04,0a2.045,2.045,0,0,1,1.352.423A1.9,1.9,0,0,1,18.6,9.6a1.887,1.887,0,0,1-1.488,1.651,2.07,2.07,0,0,1-.52.054c-.829.005-1.659,0-2.488,0",
    transform: "translate(0 0)",
    fill: "#fff"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.38268baec18fc65b6276276296fb6e9a.svg";
export { ForwardRef as ReactComponent };